export default __webpack_public_path__ + "static/media/L-A-select.0d2a1390.png";